import { formConstants as constants } from "../_constants/form.constants";

export const initialState = {
  isRetrieving: true,
  isSearching: false,
  collection: [],
  details: null,
}

export function form(state = initialState, action) {
  if (action.type === constants.FORMS_RETRIEVE_INIT) {
    return {
      ...state,
      isRetrieving: true,
      details: null
    }
  }

  if (action.type === constants.FORMS_RETRIEVE_SUCCESS) {
    return {
      ...state,
      isRetrieving: false,
      details: action.form
    }
  }

  if (action.type === constants.FORMS_RETRIEVE_REQUEST) {
    return {
      ...state,
      isRetrieving: true
    }
  }

  if (action.type === constants.FORMS_GETALL_INIT) {
    return {
      ...state,
      collection: []
    }
  }

  if (action.type === constants.FORMS_GETALL_REQUEST) {
    return {
      ...state,
      isSearching: true
    }
  }

  if (action.type === constants.FORMS_GETALL_SUCCESS) {
    return {
      ...state,
      isSearching: false,
      collection: action.collection
    }
  }

  return state;
}